import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  apiKeyData: {},
  pageFlag: 'create'
}

export const apiKeySlice = createSlice({
  name: 'apiKey',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setApiKeyDataAction: (state, action) => {
      state.apiKeyData = action.payload
    },
    setApiKeyPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setApiKeyDataAction, setApiKeyPageFlagAction } = apiKeySlice.actions

// Selectors
export const selectApiKeyData = (state) => state.apiKey.apiKeyData
export const selectApiKeyPageFlag = (state) => state.apiKey.pageFlag

// Reducer
export default apiKeySlice.reducer